module.exports = __webpack_public_path__ + "img/ycd_logo_small.8e5dbcc1.png";